import { defineMessages } from 'react-intl';

export default defineMessages({
    yes: {
        id: 'ml.quoteandbind.clausescheduleitems.yes',
        defaultMessage: 'Yes'
    },
    no: {
        id: 'ml.quoteandbind.clausescheduleitems.no',
        defaultMessage: 'No'
    },
});
